/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : PREVIEW : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	editembedname: {
		maxWidth: pxToEm(432),
        extend: [theme.modal.form],
        '& .gridset': {
        	width: '100% !important'
        }
    }
});